// type
type StorageUsageBarProps = {
    used: number,
    total: number
}

export default function StorageUsageBar(props: StorageUsageBarProps) {
    const { used, total } = props;
    const percentageUsed = (used / total) * 100;

    return (
        <div>
            <div style={{ width: '100%', overflow: 'hidden', borderRadius: '10px' }}>
                <div
                    style={{
                        width: '100%',
                        backgroundColor: '#ddd',
                    }}
                >
                    <div
                        style={{
                            width: `${percentageUsed}%`,
                            height: '20px',
                            backgroundColor: 'green',
                            borderRadius: `${percentageUsed === 100 ? '0 10px 10px 0' : '10px 0 0 10px'}`,
                        }}
                    ></div>
                </div>
            </div>
            <p>
                使用ファイル: {(used / (1024 * 1024)).toFixed(1)} MB /{' '}
                {total / (1024 * 1024 * 1024)} GB
            </p>
        </div>
    );
}
